module finadai.app.agents {
  export var NAME = "finadai.app.agents";
  function ConfigRoutes($stateProvider: ng.ui.IStateProvider, $urlRouterProvider: ng.ui.IUrlRouterProvider){
    $urlRouterProvider.when('/agents', '/agents/list');
    $stateProvider.state('app.agents', {
      templateUrl: 'app/agents/agents.tpl.html',
      url: '/agents'
    })
    .state('app.agents.list', {
      templateUrl: 'app/agents/list/list.tpl.html',
			controller: 'AgentsListController',
      url: '/list'
    })
    .state('app.agents.create', {
      templateUrl: 'app/agents/create/create.tpl.html',
			controller: 'AgentsCreateController',
      url: '/create',
      resolve: { data: () => { return {}; } }
    })
    .state('app.agents.detail', {
      templateUrl: 'app/agents/create/create.tpl.html',
			controller: 'AgentsCreateController',
      url: '/detail/:agentId',
      resolve: {
        data: (agentsService: services.AgentsService, $stateParams) => {
          return agentsService.get($stateParams.agentId).then(response => {
            return { id: response.data.data.id, name: response.data.data.name, email: response.data.data.user.email, user_id: response.data.data.user.id };
          })
        }
      }
    });
  }
  export function run(){
    var agents = angular.module(NAME, [
      finadai.app.agents.list.NAME,
      finadai.app.agents.create.NAME
    ]);
    agents.config(ConfigRoutes);
  }
}
finadai.app.agents.run();